module.exports = __webpack_public_path__ + "img/Bills@1x.107b6814.svg";